<template>
  <div class="main-container">
    <router-view></router-view>

    <!-- hero section -->
    <Hero />

    <!-- service area  -->
    <CurveShape class="no-height">
      <template v-slot:bgcolor>
        <path
          style="fill: #ffffff; stroke-miterlimit: 10"
          d="M3360.5,97.739c-242,0-480-48.375-480-48.375
                        S2647.5,0.5,2400.5,0.5s-480,48.375-480,48.375s-238,48.864-480,48.864s-480-48.375-480-48.375S727.5,0.5,480.5,0.5
                        S0.5,48.875,0.5,48.875V108h1920h1920V48.875C3840.5,48.875,3602.5,97.739,3360.5,97.739z"
        />
      </template>
    </CurveShape>
    <div
      class="
        start-ups-feature
        startup-about-feature
        section-space--pt_120 section-space--pb_60
      "
      id="about"
    >
      <div class="container">
        <div class="section-title-wrapper text-center section-space--mb_60">
          <h2 class="section-title mb-30 wow move-up">
            探索各類企業資源規劃（ERP）系統<br />升級您的業務
          </h2>
        </div>
        <!-- feature component -->
        <Features />
      </div>
    </div>

    <!-- tab conetent section -->
    <div
      class="tabs-wrapper startup-tab section-space--ptb_120 default-bg"
      id="service"
    >
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div
              class="
                section-title-wrapper
                text-center
                section-space--mb_60
                wow
                move-up
              "
            >
              <h2 class="section-title font-weight--bold mb-15">
                我們提供最優質的一站式 <br />
                科技方案開發服務
              </h2>
            </div>
          </div>
        </div>
        <!-- tab components -->
        <TabOne />
      </div>
    </div>

    <!-- tab conetent section -->
    <!-- <TabThree /> -->

    <!-- brand carousel -->
    <!-- <CarouselStartup /> -->

    <!-- contact form section -->
    <ContactForm />

    <!-- call to action  -->
    <!-- <CtaFour /> -->
  </div>
</template>

<script>
import Hero from "../../../components/cyberfire/Hero";
import CurveShape from "../../../components/CurveShape";
import Features from "../../../components/cyberfire/Features";
import TabOne from "../../../components/cyberfire/TabOne";
// import TabThree from "../../../components/cyberfire/TabThree";
// import CarouselStartup from "../../../components/CarouselStartup";
import ContactForm from "../../../components/cyberfire/ContactForm";

export default {
  name: "app",
  components: {
    Hero,
    CurveShape,
    Features,
    TabOne,
    // TabThree,
    // CarouselStartup,
    ContactForm,
  },

  metaInfo: {
    title: "Cyber Fire Limited",
    // htmlAttrs: {
    //   lang: "zh-Hant",
    //   amp: true,
    // },
  },
};
</script>

<style scoped>
.default-bg {
  background: linear-gradient(-259deg, #f4f7fe 0, #a5b4e3 65%);
}

.section-title {
  font-weight: 600;
  line-height: 1.5;
}
</style>

